(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('dobPicker', function(dateUtil, arrayUtil, $locale, broker) {
    const days = arrayUtil.numberArray(1, 31);
    const months = arrayUtil.map($locale.DATETIME_FORMATS.SHORTMONTH, function(m, i) {
        return { index: i, label: m };
    });

    return {
        restrict: 'E',
        replace: true,
        require: 'ngModel',
        templateUrl: (element, attr) => {
            let base = 'partials';
            if (attr.templateVersion) {
                return `${base}/booking/template?name=DobPicker&version=${attr.templateVersion}`;
            }
            return `${base}/home/directivetemplate?type=DobPicker`;
        },
        link(scope, el, attr, c) {
            if (!c) { return; }
            scope.dobField = attr.field;

            let thisYear = new Date().getFullYear();
            const minAge = parseInt(scope.$eval(attr.minAge));
            const age = parseInt(scope.$eval(attr.age));
            const maxAge = attr.maxAge ? parseInt(scope.$eval(attr.maxAge)) : 100;

            if (attr.ageCheck != null) {
                let date = scope.$eval(attr.ageCheck).split('T')[0];
                thisYear = new Date(date).getFullYear();
            }

            scope.days = days;
            scope.months = months;
            scope.years = arrayUtil.numberArray(thisYear - (age >= 0 ? age : minAge), age >= 0 ? thisYear - age - 1 : thisYear - maxAge);

            c.$formatters.unshift(function(val) {
                if (val == null) { return val; }
                const d = dateUtil.parseDate(val);
                if (dateUtil.isValid(d)) {
                    scope.dob = scope.dob || {};
                    scope.dob = {
                        year: d.getFullYear(),
                        month: d.getMonth(),
                        day: d.getDate()
                    };
                }
                return val;
            });

            function parse(val) {
                if (val == null || val.day == null || val.month == null || val.year == null) { return null; }
                const d = dateUtil.zeroTime(`${val.year}-${padZero(val.month + 1)}-${padZero(val.day)}`, false);
                return (dateUtil.isValid(d)) ? dateUtil.serialiseDate(d) : null;
            }

            function padZero(n) {
                return (n < 10) ? (`0${n}`) : n;
            }

            scope.$watch('dob', function(val) {
                if (val == null) { return; }
                c.$setViewValue(parse(val));
                broker.publish('dobUpdated', val);
            }, true);
        }
    };
});
})();
